'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var authViewUnapprovedDataInit = exports.authViewUnapprovedDataInit = undefined;

exports.authViewUnapprovedDataInit = authViewUnapprovedDataInit = function authViewUnapprovedDataInit(c) {
    var t = this,
        appManager = c.appManager,
        requestManager = c.requestManager;

    return {
        baseUrl: appManager.getApiPath() + '/me/authorization/F_VIEW_UNAPPROVED_DATA',
        success: function success(r) {
            appManager.viewUnapprovedData = r;
            requestManager.ok(this);
        }
    };
};
//# sourceMappingURL=authViewUnapprovedDataInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/authViewUnapprovedDataInit.js
 ** module id = 135
 ** module chunks = 0 1
 **/